import {
  FETCH_PRACTICE_TYPES,
  FETCH_PRACTICE_TYPES_SUCCESS,
  FETCH_PRACTICE_TYPES_FAILED,
  EDIT_PRACTICE_TYPE
} from "../store/types";
import { language } from 'config';

export const fetchPracticeTypes = () => (dispatch) => (firebase) => {

  const {
    practiceTypesRef
  } = firebase;

  dispatch({
    type: FETCH_PRACTICE_TYPES,
    payload: null
  });
  practiceTypesRef.on("value", snapshot => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i].id = i;
        return data[i]
      });
      dispatch({
        type: FETCH_PRACTICE_TYPES_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_PRACTICE_TYPES_FAILED,
        payload: language.no_PRACTICEs
      });
    }
  });
};

// export const editPracticeType = (practicetypes, method) => (dispatch) => (firebase) => {
//   const {
//     practiceTypesRef, 
//     practiceTypesEditRef
//   } = firebase;
//   dispatch({
//     type: EDIT_PRACTICE_TYPE,
//     payload: { method, practicetypes }
//   });
//   if (method === 'Add') {
//     practiceTypesRef.push(practicetypes);
//   } else if (method === 'Delete') {
//     practiceTypesEditRef(practicetypes.id).remove();
//   } else {
//     practiceTypesEditRef(practicetypes.id).update(practicetypes);
//   }
// }



export const editPracticeType = (practice, method) =>  (dispatch) => (firebase) => {
  const { practiceTypesRef, practiceTypesEditRef } = firebase;

  dispatch({ type: EDIT_PRACTICE_TYPE, payload: { method, practicetypes: practice } });

  try {
    if (method === "Add") {
      // create a new ref, get the key, set object with id + timestamps
      const newRef = practiceTypesRef.push();
      const id = newRef.key;
      const payload = {
        ...practice,
        id,
        createdAt: new Date().toISOString(),
      };
       newRef.set(payload);
      return payload; // resolved value
    } else if (method === "Delete") {
      if (!practice.id) throw new Error("Missing practice id for Delete");
       practiceTypesEditRef(practice.id).remove();
      return { id: practice.id, deleted: true };
    } else {
      // Update
      if (!practice.id) throw new Error("Missing practice id for Update");
      const toUpdate = {
        ...practice,
        updatedAt: new Date().toISOString(),
      };
      // Don't overwrite id with undefined
       practiceTypesEditRef(practice.id).update(toUpdate);
      return toUpdate;
    }
  } catch (err) {
    console.error("editPracticeType error:", err);
    // optional: dispatch an error action here
    throw err; // rethrow so caller can catch
  }
};